var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep118(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 74,
    viewBox: "0 0 529 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520.293 0.292893C520.683 -0.0976311 521.317 -0.0976311 521.707 0.292893L528.071 6.65685C528.462 7.04738 528.462 7.68054 528.071 8.07107C527.681 8.46159 527.047 8.46159 526.657 8.07107L521 2.41421L515.343 8.07107C514.953 8.46159 514.319 8.46159 513.929 8.07107C513.538 7.68054 513.538 7.04738 513.929 6.65686L520.293 0.292893ZM11 35.0703L511 35.0702L511 37.0702L11 37.0703L11 35.0703ZM520 26.0702L520 1L522 1L522 26.0702L520 26.0702ZM2.00001 46.0703L2.00002 74L1.55099e-05 74L9.57583e-06 46.0703L2.00001 46.0703ZM511 35.0702C515.971 35.0702 520 31.0408 520 26.0702L522 26.0702C522 32.1454 517.075 37.0702 511 37.0702L511 35.0702ZM11 37.0703C6.02943 37.0703 2.00001 41.0997 2.00001 46.0703L9.57583e-06 46.0703C8.28508e-06 39.9952 4.92487 35.0703 11 35.0703L11 37.0703Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep118);
export default __webpack_public_path__ + "static/media/laptop_step_11_8.55eb82e6d3d7c6ee26f335da45416108.svg";
export { ForwardRef as ReactComponent };